export default __webpack_public_path__ + "static/media/Huong_dan_su_dung_PriceVIP.93021258.pdf";